import { render, staticRenderFns } from "./caseClip_detail.vue?vue&type=template&id=529a51a8&scoped=true"
import script from "./caseClip_detail.vue?vue&type=script&lang=js"
export * from "./caseClip_detail.vue?vue&type=script&lang=js"
import style0 from "./caseClip_detail.vue?vue&type=style&index=0&id=529a51a8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529a51a8",
  null
  
)

export default component.exports